(function () {
  'use strict';

  function validatePhoneFormat(phone) {
    var cleaned = String(phone || '').replace(/\D/g, '');
    return cleaned.length === 10;
  }

  function formatPhoneForDisplay(phone) {
    var cleaned = String(phone || '').replace(/\D/g, '');
    if (cleaned.length !== 10) return phone;
    return '(' + cleaned.slice(0, 3) + ') ' + cleaned.slice(3, 6) + '-' + cleaned.slice(6);
  }

  function initAlishbaContactQueries() {
    var forms = document.querySelectorAll('[data-alishba-contact-query]');
    if (!forms.length) return;

    var urlParams = new URLSearchParams(window.location.search);
    var urlConcern = urlParams.get('concern');

    forms.forEach(function (form) {
      if (form.dataset.alishbaContactBound === 'true') return;

      var emailField = form.querySelector('[data-contact-query-email]');
      var phoneField = form.querySelector('[data-contact-query-phone]');
      var topicField = form.querySelector('[data-contact-query-topic]');
      var orderField = form.querySelector('[data-contact-query-order-field]');

      if (!emailField || !phoneField || !topicField) return;

      if (urlConcern && topicField) {
        topicField.value = decodeURIComponent(urlConcern);
      }

      function toggleOrderField() {
        var isOrderIssue = topicField.value === 'Order Issue';
        if (orderField) {
          orderField.classList.toggle('hidden', !isOrderIssue);
        }
      }

      function validatePhoneField() {
        var phoneValue = String(phoneField.value || '').trim();
        if (!phoneValue) {
          phoneField.setCustomValidity('');
          return true;
        }
        if (!validatePhoneFormat(phoneValue)) {
          phoneField.setCustomValidity('Please enter a valid 10-digit phone number');
          return false;
        }
        phoneField.setCustomValidity('');
        return true;
      }

      function syncValidation() {
        var hasEmail = String(emailField.value || '').trim() !== '';
        var phoneValid = validatePhoneField();
        var hasValidPhone = String(phoneField.value || '').trim() !== '' && phoneValid;
        var message = hasEmail || hasValidPhone ? '' : 'Please provide an email address or a valid phone number.';

        if (!hasEmail && !hasValidPhone) {
          emailField.setCustomValidity(message);
        } else {
          emailField.setCustomValidity('');
        }
      }

      topicField.addEventListener('change', toggleOrderField);
      emailField.addEventListener('input', syncValidation);
      phoneField.addEventListener('input', validatePhoneField);
      form.addEventListener('submit', syncValidation);

      toggleOrderField();
      syncValidation();

      form.dataset.alishbaContactBound = 'true';
    });
  }

  document.addEventListener('DOMContentLoaded', initAlishbaContactQueries);
})();
